import React from 'react'
import ModernAlert from '../../../components/alert/ModernAlert';
import Loading from '../../../components/loading/Loading';
import './login.css'
import url from '../../../url';
import axios from 'axios';
// Redux
import { connect } from "react-redux";
import { login } from "../../../redux/actions";

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            user: '',
            pass: '',
            alert: { msg: '', type: '' }
        }

    }

    login = (e) => {
        let body = {
            adminAuthForm: {
                ...this.body,
                user: this.state.user,
                pass: this.state.pass
            }
        }
        e.preventDefault();
        this.setState({ loading: true, alert: { msg: '', type: '' } })
        axios
            .post(`${url}/v2/telemetria/auth`, body)
            .then(d => {
                console.log(d.data);
                localStorage.setItem("login", JSON.stringify(d.data));
                this.props.login({ ...d.data, authenticated: true });
                setTimeout(() => {
                    this.setState({ loading: false });
                }, 500);
            })
            .catch(e => {
                this.setState({ loading: false })
                if (!e.response.data.errorMessage) {
                    this.setState({ alert: { msg: 'Algo está errado!', type: 'danger' } });
                } else if (e.response && e.response.data.errorMessage !== null) {
                    this.setState({ alert: { msg: e.response.data.errorMessage, type: 'danger' } })
                }
                console.log(e.response);
            });
    }

    render() {
        return (
            <div className='main'>
                <div className='login-components'>
                    <div className='login-img logo-telemetry' />
                    <form onSubmit={this.login} className='login-form'>
                        <input
                            type="text"
                            className='login-input'
                            placeholder='Usuário'
                            disabled={this.state.loading}
                            value={this.state.user}
                            onChange={(i) => this.setState({ user: i.target.value })}
                        />
                        <input
                            type="password"
                            // type="text"
                            className='login-input'
                            placeholder='Senha'
                            disabled={this.state.loading}
                            value={this.state.pass}
                            onChange={(i) => this.setState({ pass: i.target.value })}
                        />

                        {this.state.loading ? <div style={{ height: '40px' }}><Loading /></div> : <input type="submit" className='login-button' value='Entrar' disabled={false} />}

                        <div style={{ width: '240px', marginTop: '20px' }}>
                            <ModernAlert msg={this.state.alert.msg} color={this.state.alert.type} />
                        </div>

                    </form>

                </div>
                <div className="login-footer">
                    <div className='login-copyright copyright-icon' />
                    <span><a href="https://www.telemetry.com.br/" target="_blank" rel="noreferrer">Telemetry</a> Todos os Direitos Reservados <b>{new Date().getFullYear()}</b></span>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {};
};

const mapDispatchToProps = dispatch => {
    return {
        login: data => dispatch(login(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
